import React from 'react';
import { Modal } from 'antd';
import WidgetForm from '../widget/WidgetForm';
import { useDocumentContext } from '../../../../context/Document';

const CreateWidgetModal = ({ totalPaddingX }) => {
  const {
    isOpenCreateWidgetModal,
    setIsOpenCreateWidgetModal,
    offerId,
    documentId,
    scope,
    setWidgetCreated,
    globalVariables,
    setGlobalVariables,
    variables
  } = useDocumentContext();

  const onCancel = () => setIsOpenCreateWidgetModal(false);
  return (
    <Modal
      className="modal-widget"
      open={isOpenCreateWidgetModal}
      footer={null}
      onCancel={onCancel}
      width="90%"
      destroyOnClose
      maskClosable={false}
      keyboard={false}
      centered
      bodyStyle={{ height: '90vh', overflowY: 'auto' }}
    >
      <WidgetForm
        scope={scope}
        onCancel={onCancel}
        modalMode
        documentId={documentId}
        offerId={offerId}
        totalPaddingX={totalPaddingX}
        setWidgetCreated={setWidgetCreated}
        globalVariables={globalVariables}
        setGlobalVariables={setGlobalVariables}
        documentVariables={variables}
      />
    </Modal>
  );
};

export default CreateWidgetModal;
